export type SetType = {
  code: string
  icon_svg_uri: string
  name: string
}

export type ThemeType = {
  brief?: string
  iscardtype?: boolean
  iscreaturetheme?: boolean
  key: string
  name: string
  plural?: string
  threshold: number
  wiki?: string
}

export type TribeType = string

export type MiscStateType = {
  sets: SetType[]
  tcgplayerKickback?: {
    end: Date
    percent: number
    start: Date
  }
  tcgplayerSale: number
  themes: ThemeType[]
  tribes: TribeType[]
}

export const initialMiscState: MiscStateType = { sets: [], tcgplayerSale: 0, themes: [], tribes: [] }
